// extracted by mini-css-extract-plugin
module.exports = {"body":"idt-photoeditmodal_body__2o3fc","modal":"idt-photoeditmodal_modal__10k8v","container":"idt-photoeditmodal_container__2vxqi"};